<template>
              <table class='borderedtable' style="margin-top: 0px; padding: 0px;">
                <!-- 2025 09 12 t_field -->
                <tr v-if="userrole=='manager1'" class="bigtitle">
                  <th>t_f</th><th>時間</th> <th>入金</th> <th>支出</th> <th>BY</th> <th>項目</th> <th>詳細</th> <th>Staff</th>
                </tr>
                <tr v-else class="bigtitle">
                  <th>時間</th> <th>入金</th> <th>支出</th> <th>BY</th> <th>項目</th> <th>詳細</th> <th>Staff</th>
                </tr>
                <!--  2025 09 12 t_field
                <tr class="bigtitle">
                  <th>時間</th> <th>入金</th> <th>支出</th> <th>BY</th> <th>項目</th> <th>詳細</th> <th>Staff</th>
                </tr>
                -->
                <tr v-for="(value, index2) in smallEntries" v-bind:key="index2">
                  <!-- 2025 09 09 t_field 구현위해 추가함-->
                  <td v-if="userrole=='manager1'">
                    <base-button class="small green" @click="taxClicked(index2)">{{ add_tax_option(value.t_field) }} </base-button>
                  </td>
                  <td>{{ DateUtils.displayHourMinute(value.mydate) }}</td>
                  <td class="money">{{ FormatUtils.display_money(value.income) }}</td>
                  <td class="money">{{ FormatUtils.display_money(value.outcome) }}</td>
                  <td>{{ (value.method) }}</td>
                  <!-- 2025 09 15 t_field -->
                  <td :class="{ 'strikeout': userrole=='manager1' && value.t_field==1 }">
                    {{ value.what }}
                  </td>
                  <!-- 2025 09 15 t_field<td>{{ value.what }}</td> -->
                  <td>{{ value.note }}</td>
                  <td>{{ value.staff }}</td>
                </tr >
              </table>
              <table class='borderedtable'>
                <tr class="bigtitle2">
                  <th></th>
                  <th>現金(入)</th><th>現金(出)</th><th>card</th><th>gmo</th><th>meta</th><th>bank</th><th>TOTAL</th>
                </tr>
                <tr>
                  <td class="total">TOTAL</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats_small_entries.cashin) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats_small_entries.cashout) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats_small_entries.card) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats_small_entries.gmo) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats_small_entries.meta) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(stats_small_entries.bank) }}</td>
                  <td class="money total"> {{ FormatUtils.display_money(gettotal()) }}</td>
                </tr>
                <tr v-if="userrole=='manager1'">
                  <td class="total">TOTAL</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats_small_entries.cashin2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats_small_entries.cashout2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats_small_entries.card2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats_small_entries.gmo2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats_small_entries.meta2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(stats_small_entries.bank2) }}</td>
                  <td class="money total strikeout"> {{ FormatUtils.display_money(gettotal2()) }}</td>
                </tr>
              </table>
</template>
<script>
import {FormatUtils} from '@/classes/Utils/FormatUtils.js';
import {DateUtils} from '@/classes/Utils/DateUtils.js';
import { accounting } from '@/classes/Accounting.js';
// 2025 09 12 t_field
import { userinfo } from '@/classes/UserInfo.js';

import { computed } from 'vue';
//import { jsPDF } from "jspdf";
export default {

    name: 'DailySmallAccounting',

    setup() {

      const smallEntries = computed(() =>  accounting.get_small_entries() );
      const day_normal_payentries = computed(() =>  accounting.get_day_normal_payentries() );
      const stats_small_entries = computed(() => accounting.get_stats_small_entries() );
      const moneyCounting = computed(() => accounting.get_money_counting() );

      // 250907 t_field
      const userrole = computed(() => userinfo.get_userrole())

        // 250907 t_field
        function taxClicked(myindex) {
            var new_t_field = 0;
            if (smallEntries.value[myindex].t_field=='1') new_t_field = '0';
            if (smallEntries.value[myindex].t_field=='0') new_t_field = '1';
            var mydata = {
                id: smallEntries.value[myindex].id,
                new_t_field: new_t_field
            }
            //console.log('taxclicked');
            //console.log('myindex = ' + myindex)
            //console.log('mybookinglist.value[myindex] = ' + myBookingList.value[myindex].booking.dataid)
            //console.log(myBookingList.value[myindex])
            //console.log(mydata)
            process_tax_click(mydata);
        }
        async function process_tax_click(mydata) {
            await accounting.set_t_field_small_accounting(mydata);
            await accounting.refetch();
        }

  // 20250906 to display checked mark or 
  function add_tax_option(t_field) {
    var build="";
    if (t_field=='1') build="❌";
    else build="💰"
    return build;
  }




      function gettotal() {
        var temp = Number(0);
        temp = Number(0) + Number(stats_small_entries.value.cashin) + Number(stats_small_entries.value.cashout) +
               Number(stats_small_entries.value.card) + Number(stats_small_entries.value.gmo) +
               Number(stats_small_entries.value.meta) + Number(stats_small_entries.value.bank);
        return temp;
      }
      function gettotal2() {
        var temp = Number(0);
        temp = Number(0) + Number(stats_small_entries.value.cashin2) + Number(stats_small_entries.value.cashout2) +
               Number(stats_small_entries.value.card2) + Number(stats_small_entries.value.gmo2) +
               Number(stats_small_entries.value.meta2) + Number(stats_small_entries.value.bank2);
        return temp;
      }

      return {  FormatUtils, DateUtils, gettotal, gettotal2, 
                day_normal_payentries, smallEntries, stats_small_entries, moneyCounting, userrole, taxClicked, add_tax_option  }
    },
};
</script>


<style scoped>
.strikeout {
  /*text-decoration: line-through; */
  text-decoration: line-through;
  text-decoration-style: double;
  color: red; /* Optional: grey out completed tasks */
}

.borderedtable {
    border: 1px solid black;
    border-collapse: collapse;
    width: 100%;
}
.border {
    border: 1px solid black;
    border-collapse: collapse;
}


      .black {
        color: black;
      }
      .red {
        color: red;
      }

    .yes {
        color:white;
        background-color: green;
      }
    .no {
        color: white;
        background-color: red;
      }
</style>
